import React from 'react';
import ApplicationReviewContainer from 'features/ApplicationReview';

const ApplicationReviewPage = () => <ApplicationReviewContainer />;

export default ApplicationReviewPage;
